<h3>Clone: {{ editDetails?.formTitle }}</h3>
<app-team-edit-details #editDetails [teamId]="teamId" [cloneMode]="true"> </app-team-edit-details>
<mat-dialog-actions>
  <button mat-raised-button color="primary" [disabled]="!editDetails.valid || saving" (click)="cloneTeam()">
    CREATE
  </button>
  <button type="button" mat-button (click)="dialogRef.close()">CANCEL</button>
</mat-dialog-actions>
